export default "__VITE_ASSET__BhpYBxwJ__"